export const styleVariables = {
  size: 320,
  mobile_small: 320,
  mobile_medium: 375,
  mobile_large: 480,
  size_px: "320px",
  text_color: "#263238"
};
